
window.filterGlobalnewsContent = function() {
	var year = document.querySelector('#selected_year').value;
	var month = document.querySelector('#selected_month').value;
	var categoryId = document.querySelector('#category_id').value;
	var url = filterSubimitUrl;
	if (url === '') {
		return;
	}

	if (year > 0) {
		url += '/_' + year;
		if (month > 0) {
			url += '-' + ((month > 9) ? month : '0' + month);
		}
	}

	if (categoryId > 0) {
		url += '/c' + categoryId;
	}

	window.location = url;
	
};

